module.exports = __webpack_public_path__ + "img/tech_service.508eb41b.png";